import React, { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle"
import CILabel from "components/Common/CILabel";
import { getFinancierPref } from "http/fundLync/financier.helper";
import { decryptedValue, uId } from "common/utility";
import "./fin-pre.scss"
import { useNavigate } from "react-router-dom";


const ViewFinPreference = () => {
    document.title = "Financier Preference | FundLync"
    const user = decryptedValue(localStorage.getItem("user"));
    const navigate = useNavigate();
    const [prefrence, setPrefrence] = useState()

    useEffect(() => {
        
        const urlParams = new URLSearchParams(window.location.search);
        const encodedId = urlParams.get("id");
        const decodedId = atob(encodedId);
        if(decodedId)
        {
        
            fetchFinPreferenceData(decodedId)
        }
       
    }, [])

    const fetchFinPreferenceData = (id)=>{
        getFinancierPref({id})
        .then((result) => {
            const {status,data} = result
            if(status)
            {
                try {
                    const dataObj ={
                        financier:data.financier,
                        minimumRating:data.minimumRating,
                        negativeIndustries:data.negativeIndustries,
                        preferredIndustries:data.preferredIndustries,
                        products:data.products.map((obj)=>Object.assign(obj,{id:uId()})),
                        geographicalValue:data.coveredGeography,
                        payoutToCi:data.payoutToCi,
                        maxTurnOver: data.maxTurnOver,
                        minTurnOver: data.minTurnOver,
                        integrationWithCi:data.integrationWithCi,
                    }
                    setPrefrence(dataObj)
                } catch (error) {
                    console.log(error);
                }
               
            }

        }).catch((error) => {
            console.error(error)
        });
    } 

    const navigateToListItem = () => {
        navigate(`/${user.roleName}/financer-preference`);
    };


    return (
            <div className="page-content">
                <Container fluid>
                <div className="d-flex gap-3 justify-content-between">
                <Breadcrumbs title="View Financier Preference" />
                                  <button
                                    className="btn btn-outline-secondary me-3"
                                    type="button"
                                    onClick={() => navigateToListItem()}
                                  >
                                    Back
                                  </button>
                                </div>
                  
                    { prefrence && 
                    <div className="vertical-scroll">
                       <Row>
                        <Col lg='6' sm='12'>
                            <CILabel 
                                label={'Financier Name'}
                                value={prefrence.financier.entityName}/>
                        </Col>
                        <Col lg='6' sm='12'>
                        <CILabel 
                                label={'Minimum Rating Requirement'}
                                value={prefrence.minimumRating}/>
                        </Col>
                        <Col lg='6' sm='12'>
                        <CILabel 
                                label={'Geographies Covered'}
                                value={prefrence.geographicalValue.map((obj)=>obj.displayName).join(', ')}/>
                        </Col>
                        <Col lg='6' sm='12'>
                        <CILabel 
                                label={'Payout to CI'}
                                value={`${prefrence.payoutToCi}%`}/>
                        </Col>
                        <Col lg='6' sm='12'>
                        <CILabel 
                                label={'Minimum Turnover'}
                                value={`${formatNumberWithCommas(prefrence.minTurnOver) || '-'}`}/>
                        </Col>
                        <Col lg='6' sm='12'>
                        <CILabel 
                                label={'Maximum Turnover'}
                                value={`${formatNumberWithCommas(prefrence.maxTurnOver) || '-'}`}/>
                        </Col>
                        <Col lg='6' sm='12'>
                        <CILabel 
                                label={'Integration with CI'}
                                value={`${prefrence.integrationWithCi.charAt(0).toUpperCase()}${prefrence.integrationWithCi.slice(1)}`}/>
                        </Col>
                        <Col lg='6' sm='12'>
                                <label className="mt-3 form-label">{'Preferred Industries'}</label>
                                {prefrence.preferredIndustries?.map((obj)=>{
                                    return (<div key={obj.id} className="chip-div">
                                            <span className="chip-label">{obj.industryName}</span>
                                    </div>)

                                })}
                            
                        </Col>
                        <Col lg='6' sm='12'>
                                <label className="mt-3 form-label">{'Negative Industries'}</label>
                                {prefrence.negativeIndustries?.map((obj)=>{
                                    return (<div key={obj.id} className="chip-div">
                                            <span className="chip-label">{obj.industryName}</span>
                                    </div>)

                                })}
                            
                        </Col>
                        <Col sm="12">
                        <h4 className="form-label mt-4">Products</h4>
                            <Table
                                Table
                                striped
                                bordered
                                hover
                                style={{ width: "100%", backgroundColor: "white" }}
                            >
                                 <thead>
                                    <tr>
                                        <th>Product Type</th>
                                        <th>Product</th>
                                        <th>Sub Product</th>
                                        <th>Min ROI (in %)</th>
                                        <th>Max ROI (in %)</th>
                                        <th>Min Sanction Amount</th>
                                        <th>Max Sanction Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {prefrence.products?.map((obj)=>{
                                        return (
                                            <tr key={obj.id}>
                                            <td style={{ width: '20%' }} >
                                                <span>{obj.productType[0].displayName}</span>
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                <span>{obj.productID[0].displayName}</span>
                                            </td>
                                            {/* {obj?.subProduct && ( */}
                                                <td style={{ width: '20%' }}>
                                            <span>{obj.subProduct.join(', ')}</span>
                                            </td>
                                            {/* )} */}
                                            
                                            <td style={{ width: '15%' }}>
                                                <span>{obj.minPriceRange}</span>
                                            </td>
                                            <td style={{ width: '15%' }}>
                                                <span>{obj.maxPriceRange}</span>
                                            </td>
                                            <td style={{ width: '15%' }}>
                                                <span>{obj.minSanctionAmt}</span>
                                            </td>
                                            <td style={{ width: '15%' }}>
                                                <span>{obj.maxSanctionAmt}</span>
                                            </td>
                                        </tr>

                                        )
                                    }) }
                               
                                </tbody>
                            </Table>
                        </Col>
             
                        </Row>
                    </div>
                    }
                </Container>
            </div>
    )


}
const formatNumberWithCommas = (number) => {
    if (number) {
      const formattedNumber = number.toString().replace(/\./, ",");
      const parts = formattedNumber.split(",");
      if (parts[0].length > 3) {
        const lastThree = parts[0].substr(parts[0].length - 3);
        const remaining = parts[0].slice(0, parts[0].length - 3);
        parts[0] =
          remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
      }
  
      return "₹" + " " + parts.join(".");
    }
  };
export default ViewFinPreference